'use client';

import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface FieldProps {
  label: ReactNode;
  children: ReactNode;
  /** Rare: only when the label alone is genuinely ambiguous. */
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  className?: string;
}

export function Field({ label, children, hint, error, required, className }: FieldProps) {
  return (
    <label className={cn('flex min-w-0 flex-col gap-1', className)}>
      <span className="flex items-baseline gap-1 text-sm font-medium text-zinc-300">
        {label}
        {required ? <span aria-hidden className="text-accent-bright">*</span> : null}
      </span>
      {children}
      {error ? (
        <span className="text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="text-xs text-zinc-500">{hint}</span>
      ) : null}
    </label>
  );
}
